<button type="button" class="btn btn-lg btn-primary btn-block" (click)="showPopup()">
  <span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span>
  Änderungen anzeigen
</button>

<dx-popup class="popup"
          [height]="'80%'"
          [width]="'80%'"
          title="Änderungen im Antrag"
          [showTitle]="true"
          [(visible)]="popupVisible">
  <div *dxTemplate="let popup of 'content'" class="aenderungen-popup-content">
    <dx-load-panel [visible]="loading" [showIndicator]="true" [showPane]="true"></dx-load-panel>

    <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>

    <ng-container *ngIf="!loading && !errorMessage">
      <div *ngIf="getHeCount(data.he) > 0" class="panel panel-default">
        <button type="button" class="panel-heading aenderungen-heading" (click)="toggle('he')">
          <span class="glyphicon" [ngClass]="isOpen('he') ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-right'" aria-hidden="true"></span>
          <strong>{{data.he.name || 'Haupteinrichtung'}}</strong>
          <span class="badge">{{getHeCount(data.he)}}</span>
        </button>
        <div *ngIf="isOpen('he')" class="panel-body">
          <ng-container *ngTemplateOutlet="konzeption; context: {$implicit: data.he.konzeption, key: 'he-konzeption'}"></ng-container>

          <div *ngFor="let anhang of data.he.anhaenge; let index = index" class="aenderungen-block">
            <button type="button" class="aenderungen-subheading" (click)="toggle('he-anhang-' + index)">
              <span class="glyphicon" [ngClass]="isOpen('he-anhang-' + index) ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-right'" aria-hidden="true"></span>
              {{anhang.propertyName || anhang.kategorie || 'Anhang'}}
              <span class="badge">{{getEntryCount(anhang)}}</span>
            </button>
            <div *ngIf="isOpen('he-anhang-' + index)" class="aenderungen-details">
              <p *ngIf="anhang.status" class="text-info">{{anhang.status}}</p>
              <ng-container *ngTemplateOutlet="documents; context: {$implicit: anhang.documents}"></ng-container>
            </div>
          </div>
        </div>
      </div>

      <div *ngFor="let ue of data.ues" class="panel panel-default">
        <button type="button" class="panel-heading aenderungen-heading" (click)="toggle('ue-' + ue.entityId)">
          <span class="glyphicon" [ngClass]="isOpen('ue-' + ue.entityId) ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-right'" aria-hidden="true"></span>
          <strong>{{ue.name}}</strong>
          <span class="badge">{{getUeCount(ue)}}</span>
        </button>
        <div *ngIf="isOpen('ue-' + ue.entityId)" class="panel-body">
          <p *ngIf="getUeCount(ue) === 0" class="text-muted">Keine Änderungen</p>
          <div *ngIf="ue.stamm && ue.stamm.length" class="aenderungen-block">
            <button type="button" class="aenderungen-subheading" (click)="toggle('ue-stamm-' + ue.entityId)">
              <span class="glyphicon" [ngClass]="isOpen('ue-stamm-' + ue.entityId) ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-right'" aria-hidden="true"></span>
              Stammdaten <span class="badge">{{ue.stamm.length}}</span>
            </button>
            <div *ngIf="isOpen('ue-stamm-' + ue.entityId)" class="aenderungen-details">
              <ng-container *ngTemplateOutlet="items; context: {$implicit: ue.stamm}"></ng-container>
            </div>
          </div>

          <ng-container *ngTemplateOutlet="konzeption; context: {$implicit: ue.konzeption, key: 'ue-konzeption-' + ue.entityId}"></ng-container>

          <div *ngFor="let personal of ue.personal; let index = index" class="aenderungen-block">
            <button *ngIf="getEntryCount(personal) > 0" type="button" class="aenderungen-subheading" (click)="toggle('personal-' + ue.entityId + '-' + index)">
              <span class="glyphicon" [ngClass]="isOpen('personal-' + ue.entityId + '-' + index) ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-right'" aria-hidden="true"></span>
              {{personal.name || 'Personal'}}
              <small *ngIf="personal.taetigkeit">({{personal.taetigkeit}})</small>
              <span class="badge">{{getEntryCount(personal)}}</span>
            </button>
            <div *ngIf="getEntryCount(personal) > 0 && isOpen('personal-' + ue.entityId + '-' + index)" class="aenderungen-details">
              <p *ngIf="personal.status" class="text-info">{{personal.status}}</p>
              <ng-container *ngTemplateOutlet="items; context: {$implicit: personal.items}"></ng-container>
              <ng-container *ngTemplateOutlet="documents; context: {$implicit: personal.documents}"></ng-container>
            </div>
          </div>
        </div>
      </div>

      <p *ngIf="getHeCount(data.he) === 0 && (!data.ues || data.ues.length === 0)" class="text-muted">
        Es wurden keine Änderungen gefunden.
      </p>
    </ng-container>
  </div>

  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{text: 'Schließen', onClick: hidePopup}"></dxi-popup-toolbar-item>
</dx-popup>

<ng-template #konzeption let-value let-key="key">
  <div *ngIf="getKonzeptionCount(value) > 0" class="aenderungen-block">
    <button type="button" class="aenderungen-subheading" (click)="toggle(key)">
      <span class="glyphicon" [ngClass]="isOpen(key) ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-right'" aria-hidden="true"></span>
      Konzeption <span class="badge">{{getKonzeptionCount(value)}}</span>
    </button>
    <div *ngIf="isOpen(key)" class="aenderungen-details">
      <p *ngIf="value.status" class="text-info">{{value.status}}</p>
      <ng-container *ngTemplateOutlet="items; context: {$implicit: value.items}"></ng-container>
      <ng-container *ngTemplateOutlet="documents; context: {$implicit: value.documents}"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #items let-values>
  <dx-data-grid *ngIf="values && values.length"
                [dataSource]="values"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                [showBorders]="true"
                [rowAlternationEnabled]="true">
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxi-column dataField="propertyName" caption="Name"></dxi-column>
    <dxi-column dataField="alt" caption="Alt"></dxi-column>
    <dxi-column dataField="neu" caption="Neu"></dxi-column>
  </dx-data-grid>
</ng-template>

<ng-template #documents let-values>
  <dx-data-grid *ngIf="values && values.length"
                [dataSource]="values"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                [showBorders]="true">
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxi-column dataField="created" dataType="date" format="dd.MM.yyyy" caption="Erstellungsdatum"></dxi-column>
    <dxi-column dataField="bezeichnung" caption="Bezeichnung"></dxi-column>
    <dxi-column dataField="orgFileName" caption="Datei"></dxi-column>
  </dx-data-grid>
</ng-template>